import { FC, ReactNode, useCallback } from 'react';
import noop from 'lodash-es/noop';
import ButtonsSet from '@stripcash/ui-kit/components/ButtonsSet';
import Button, {
  ButtonColor,
  ButtonVariant,
} from '@stripcash/ui-kit/components/Button';
import Modal, { ModalSizes } from '@stripcash/ui-kit/components/Modal';

import styles from './styles.module.css';

type ConfirmationModalProps = {
  onClose: () => void;
  params: {
    cancelText?: string;
    okText: string;
    titleText?: string;
    descriptionText?: string;
    hideCancelButton?: boolean;
    customFooter?: ReactNode;
    successCallback?: () => void;
    declineCallback?: () => void;
  };
};

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  onClose,
  params: {
    successCallback = noop,
    declineCallback = noop,

    cancelText = 'Cancel',
    descriptionText,
    hideCancelButton,
    okText = 'OK',
    titleText,
    customFooter,
  },
}) => {
  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();

      successCallback();
      onClose();
    },
    [successCallback, onClose],
  );

  const handleHide = useCallback(() => {
    declineCallback();
    onClose();
  }, [declineCallback, onClose]);

  return (
    <form onSubmit={handleSubmit}>
      <Modal
        isGlobal
        size={ModalSizes.Small}
        header={titleText}
        onClose={handleHide}
        footer={
          customFooter ? (
            <div className={styles.customFooter}>{customFooter}</div>
          ) : (
            <ButtonsSet>
              {!hideCancelButton && (
                <Button variant={ButtonVariant.Secondary} onClick={handleHide}>
                  {cancelText}
                </Button>
              )}
              <Button
                type="submit"
                variant={ButtonVariant.PrimaryContrast}
                color={ButtonColor.Blue}
              >
                {okText}
              </Button>
            </ButtonsSet>
          )
        }
      >
        {descriptionText}
      </Modal>
    </form>
  );
};

export default ConfirmationModal;
